import React from 'react'
import { Routes, Route } from 'react-router-dom'
import RoleRoute from '@BUP/routes/RoleRoute'
import ModeBupRoute from '@BUP/routes/ModeBupRoute'
import LogbookRoute from '@BUP/routes/logbook'
import DataNavigation from '@BUP/navigations/DataNavigation'
import CourseNavigation from '@BUP/navigations/CourseNavigation'
import MySchoolNavigation from '@BUP/navigations/MySchoolNavigation'
import ResourcesNavigation from '@BUP/navigations/ResourcesNavigation'
import ModeBupNavigation from '@BUP/navigations/ModeBupNavigation'
import LogbookNavigation from '@BUP/navigations/logbook'
import SociogramNavigation from '@BUP/navigations/SociogramNavigation'
import MainLayout from '@BUP/components/Layout/Main'
import HomePage from '@BUP/pages/Home'
import ProfilePage from '@BUP/pages/Profile'
import WorkGroupPage from '@BUP/pages/Data/sociogram/workGroupPage'
import { UserContextProvider } from '@BUP/contexts/UserContext'
import { EnrollmentContextProvider } from '@BUP/contexts/EnrollmentContext'
import { IsParticipantContextProvider } from '@BUP/contexts/IsParticipantContext'
import { DiagnosisContextProvider } from '@BUP/contexts/DiagnosisContext'
import { UtilsProvider } from '@BUP/contexts/utils-provider'
import { FeatureFlagNotificationContextProvider } from '@BUP/contexts/FeatureFlagNotificationContext'

const AppNavigation = () => {
  return (
    <UserContextProvider>
      <EnrollmentContextProvider>
        <IsParticipantContextProvider>
          <DiagnosisContextProvider>
            <UtilsProvider>
              <FeatureFlagNotificationContextProvider>
                <MainLayout>
                  <Routes>
                    <Route
                      path='/'
                      element={<HomePage />}
                    />
                    <Route
                      path='/course/*'
                      element={<CourseNavigation />}
                    />
                    <Route
                      path='/schoolpage/*'
                      element={<MySchoolNavigation />}
                    />
                    <Route
                      path='/profile'
                      element={<ProfilePage />}
                    />
                    <Route
                      path='/data/*'
                      element={<DataNavigation />}
                    />
                    <Route
                      path='/resources/*'
                      element={<ResourcesNavigation />}
                    />
                    <Route
                      path='/sociogram/*'
                      element={<SociogramNavigation />}
                    />
                    <Route
                      path='/modebup/*'
                      element={
                        <ModeBupRoute>
                          <ModeBupNavigation />
                        </ModeBupRoute>
                      }
                    />
                    <Route
                      path='/logbook/*'
                      element={
                        <LogbookRoute>
                          <LogbookNavigation />
                        </LogbookRoute>
                      }
                    />
                    <Route
                      path='/work-group-page'
                      element={<WorkGroupPage />}
                    />
                  </Routes>
                </MainLayout>
              </FeatureFlagNotificationContextProvider>
            </UtilsProvider>
          </DiagnosisContextProvider>
        </IsParticipantContextProvider>
      </EnrollmentContextProvider>
    </UserContextProvider>
  )
}

export default AppNavigation
